import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'

import SummaryBackTo from './SummaryBackTo'

function SearchSummary({
  clearSelection,
  closeDetails,
  hasDetails,
  selectedStoresCount,
  showSelectedOnly,
  toggleShowSelectedOnly,
}) {
  const { t: translate } = useTranslation()

  if (hasDetails) {
    return <SummaryBackTo onClick={closeDetails} title={translate('search.backToResults')} />
  }

  if (showSelectedOnly) {
    return <SummaryBackTo onClick={toggleShowSelectedOnly} title={translate('search.back')} />
  }

  return (
    <Box className="search-control_summary">
      <span className="search-control_summary-result">
        {translate('search.found', {
          count: selectedStoresCount,
          stores: translate(['search.shopSingle', 'search.shopMulti', 'search.shopMulti2', 'n'], { n: selectedStoresCount }),
        })}
      </span>
      <Box
        display="inline"
        className={classNames('search-control_summary-action', { disabled: selectedStoresCount === 0 })}
        onClick={selectedStoresCount > 0 ? clearSelection : undefined}
      >
        {translate('search.clear')}
      </Box>
      <Box
        display="inline"
        className={classNames('search-control_summary-action', { disabled: selectedStoresCount === 0 })}
        onClick={selectedStoresCount > 0 ? toggleShowSelectedOnly : undefined}
      >
        {translate('search.view')}
      </Box>
    </Box>
  )
}

SearchSummary.propTypes = {
  clearSelection: PropTypes.func,
  closeDetails: PropTypes.func,
  hasDetails: PropTypes.bool,
  selectedStoresCount: PropTypes.number,
  showSelectedOnly: PropTypes.bool,
  toggleShowSelectedOnly: PropTypes.func,
}

export default SearchSummary
